import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Select2Multiple from 'v-select2-multiple-component';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import axios from "axios";
import store from '../../store';
import CONFIG from "@/assets/js/config.js";
import {
    required,maxLength
} from "vuelidate/lib/validators";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "gradingEdit",
    components: {
        MainLayout,
        Select2Multiple,
        flatPickr,
        Loading
    },

    data() {
        return {
            isLoading: false,
            noDataMsg: CONFIG.NO_DATA_EXIST,
            classData: {},
            remark: '',
            selectedClass: 0,
            selectedYear: 0,
            classArr: [],
            subjectArr: [],
            studentNameArr: [],
            examNameArr: [],
            academic_year: '',
            academicYear: '',
            exam_id: '',
            class_id: '',
            gradingSelected: 0,
            student_id: 0,
            grading_id: 0,
            subject_id: -1,
            academicYearArr: null,
            gradingArr: null,
            submitted: false,
            gradingInfo: {},
            gradeData: {},
            firstmark_ErrMsg: [],
            firstgrade_ErrMsg: [], 
            msgCount: 0,
            comment_msg: [],
            cmt: 0,
            cmtCount: 0,
            subject_ErrMsg: '',
            marks: [],
            grades: [],
            comment: [],
            secondmark_ErrMsg: [],
            secondgrade_ErrMsg: [],
            secondcomment_msg: [],
            second_cmt: 0,
            isError: false,
            VALID_GRADES: '',
        };
    },

    validations: {
        class_id: {
            required
        },
        academic_year: {
            required
        },
        student_id: {
            required
        },
        subject_id: {
            required
        },
        exam_id: {
            required
        },
        remark: {
            maxLength: maxLength(1000)
        },
    },

    computed: {
        allGradesAndMarksEmpty() {
            return this.gradeData.every(item =>
                (item.mark === '' || item.mark == null) &&
                (item.grade === '' || item.grade == null)
            );  
        }
    },

    methods: {

        getAcademicYear() {
            axios.get('getAcademicYear', {
              params: {
                  campus_id: store.state.user.campus_id
              }
          })
                .then(res => {
                let $defaultSelectOption = [{
                    'id': 0,
                    'text': 'Select'
                }];
                this.academicYearArr = $defaultSelectOption.concat(res.data.academicYearArr);
                }).catch((error) => {
                if (error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                }
                this.isLoading = false;
                });
        },
        
        changeEvent(val, fieldName) {
            this.submitted = false;
            this.$set(this, fieldName, val);
            if (fieldName == "academic_year") {
                this.isLoading = true;
                this.class_id = 0;
                this.selectedClass = 0;
                this.student_id = '';
                this.subject_ErrMsg = '';
                this.studentNameArr = [];
                this.firstmark_ErrMsg = [];
                this.firstgrade_ErrMsg = [];
                this.examNameArr = [];
                this.comment_msg = [];
                this.classArr = [];
                this.gradeData.forEach((value, index) => {
                    this.gradeData[index]['grading'] = 0;
                    this.gradeData[index]['grading_comment'] = '';
                });
                this.marks = [];
                this.grades = [];
                this.comment = [];
                this.secondmark_ErrMsg = [];
                this.secondgrade_ErrMsg = [];
                this.secondcomment_msg = [];
                this.getClass(val);
            }
            if (fieldName == "class_id") {
                this.isLoading = true;
                this.subject_id = -1;
                this.student_id = '';
                this.subject_ErrMsg = '';
                this.studentNameArr = [];
                this.firstmark_ErrMsg = [];
                this.firstgrade_ErrMsg = [];
                this.comment_msg = [];
                this.subjectArr = [];
                this.gradeData.forEach((value, index) => {
                    this.gradeData[index]['grading'] = 0;
                    this.gradeData[index]['grading_comment'] = '';
                });
                this.marks = [];
                this.grades = [];
                this.comment = [];
                this.secondmark_ErrMsg = [];
                this.secondgrade_ErrMsg = [];
                this.secondcomment_msg = [];
                this.getSubjectByClassId(val);
            }
        },

        changeEventSubject(val, index) {
            let fieldName = val.target.name;
            let errMsg = (fieldName == 'mark') ? this.firstmark_ErrMsg : this.firstgrade_ErrMsg;
            if (val === null || val === '') {
                errMsg[index] = 'Please Enter Student ' + fieldName;
            } else {
                errMsg[index] = '';
            }
        },

        changeEventSubjectForItem(val, index) {
            let fieldName = val.target.name;
            let errMsg = (fieldName == 'mark') ? this.secondmark_ErrMsg : this.secondgrade_ErrMsg;
            if (val === null || val === '') {
                errMsg[index] = 'Please Enter Student ' + fieldName;
            } else {
                errMsg[index] = '';
            }
        },

        async getGradingDetail() {
            try {
                const response = await axios.get("/grading/detail/" + this.$route.params.student_id, {
                    params: {
                        campus_id: store.state.user.campus_id,
                        exam_id: this.$route.params.exam_id
                    }
                })
                if (response.data[0] != undefined) {
                    this.gradingInfo = response.data[0];
                    this.gradeData = response.data;
                    this.selectedYear = this.gradingInfo.academic_year;
                    this.student_id = this.gradingInfo.student_id;
                    this.exam_id = this.gradingInfo.exam_id;
                    this.subject_id = this.gradingInfo.subject_id;
                    this.selectedClass = this.gradingInfo.class_id;
                    this.class_id = this.gradingInfo.class_id;
                    this.academic_year = this.gradingInfo.academic_year;
                    this.gradingSelected = this.gradingInfo.grading;
                    await this.getClass(this.selectedYear);
                    await this.getSubjectByClassId(this.selectedClass);
                    await this.getStudentName(this.selectedClass);
                    await this.getExamforClass(this.selectedClass);
                    this.isLoading = false;
                }
            } catch (error) {
                if (error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                }
                console.log("Grading Detail API Error", error);
                this.isLoading = false;
            }
        },

        async getClass(yearId) {
            try {
                const response = await axios.get("class/classList/" + yearId, {
                    params: {
                        campus_id: store.state.user.campus_id
                    }
                });
                
                if (response.data) {
                    let defaultSelectOption = [{
                        'id': 0,
                        'text': 'Select Class'
                    }];
            
                    this.classArr = defaultSelectOption.concat(response.data);
                }
            } catch (error) {
                if (error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                }
                console.error("Error fetching class list:", error);
            } finally {
                this.isLoading = false;
            }
        },
        
        async getExamforClass(class_id) {
            try {
                const res = await axios.get("exam/examList", {
                    params: {
                        class_id: class_id,
                        campus_id: store.state.user.campus_id
                    }
                })
                    let $defaultSelectOption = [{
                        'id': 0,
                        'text': 'Select Exam'
                    }];
                    this.examNameArr = $defaultSelectOption.concat(res.data);
                } catch(error) {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                } finally {
                    this.isLoading = false;
                }
        },

        async getStudentName(classId) {
            try {
                const response = await axios.get("student/getStudentName/" + classId, {
                    params: {
                        campus_id: store.state.user.campus_id
                    }
                });
        
                if (response.data) {
                    let defaultSelectOption = [{
                        'id': 0,
                        'text': 'Select Student Name'
                    }];
                    this.studentNameArr = defaultSelectOption.concat(response.data);
                }
            } catch (error) {
                if (error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                }
                console.error("Error fetching student names:", error);
            } finally {
                this.isLoading = false;
            }
        },

        getThisAcademicYear() {
          axios.get('period/getThisPeriod')
            .then(res => {
              this.academicYear = res.data;
              this.academic_year = this.academicYear.id;
              this.getClass(this.academic_year);
            }).catch((error) => {
              if (error.response.status == 401) {
                this.$store.commit('logout');
                window.location.replace('login');
              }
              this.isLoading = false;
            });
        },

        async getSubjectByClassId(classId) {
            try {
                const response = await axios.get("/class/subjectByClassId/" + classId, {
                    params: {
                        campus_id: store.state.user.campus_id,
                        acd_year_id: this.academic_year
                    }
                });
                if (response.data) {
                    this.subjectArr = response.data.subjectArr[0];
                }
            } catch (error) {
                if (error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                }
                console.log("Subject API Error", error);
            } finally {
                this.isLoading = false;
            }
        },

        async getValidGrades() {
            try {
              const response = await axios.get('grading/valid-grades');
              if (response) {
                this.VALID_GRADES = response.data;  
              }
            } catch (error) {
              if (error.response.status == 401) {
                this.$store.commit('logout');
                window.location.replace('login');
              }
                this.isLoading = false;
            }
        },

        confirmUpdate() {
            this.msgCount = 0;
            this.cmtCount = 0;
            this.submitted = true;
            this.isLoading = true;
            this.grades = this.grades.map(grade => grade ? grade.trim() : '');
            this.gradeData = this.gradeData.map(item => {
                item.grade = item.grade ? item.grade.trim() : '';
                return item;
            });

            if (this.$v.$invalid || this.class_id == '' || this.class_id == 0 || this.academic_year == '' || this.academic_year == 0 || this.student_id == '' || this.student_id == 0 || this.exam_id == '' || this.exam_id == 0 || this.isError) {
                if (this.gradeData.length > 0) {
                    this.gradeData.forEach((value, index) => {
                        this.cmt = this.gradeData[index]['grading_comment'] ? this.gradeData[index]['grading_comment'].length : 0;
                        if (this.cmt > 1000) {
                            this.comment_msg[index] = 'Grading Comment';
                            this.cmtCount++;
                        } else {
                            this.comment_msg[index] = '';
                        }

                        this.validateGradeData(index);
                    });
                    this.subject_ErrMsg = '';
                } else {
                    this.subject_ErrMsg = "Subject Data doesn't exist according to Grade";
                }

                for (let index = this.gradeData.length; index < this.subjectArr.length; index++) {
                    this.second_cmt = this.comment[index] ? this.comment[index].length : 0;
                    if (this.second_cmt > 1000) {
                        this.secondcomment_msg[index] = 'Grading Comment';
                        this.cmtCount++;
                    } else {
                        this.secondcomment_msg[index] = '';
                    }
                    
                    this.validateSubjectArrData(index);                    
                }

                this.subject_ErrMsg = '';

                if (this.msgCount > 0 || this.cmtCount > 0 || this.subject_ErrMsg != '' || this.isError) {
                    this.isLoading = false;
                    return;
                }
                this.isLoading = false;
                return;
            } else {
                if (this.gradeData.length > 0) {
                    this.gradeData.forEach((value, index) => {
                        this.cmt = this.gradeData[index]['grading_comment'] ? this.gradeData[index]['grading_comment'].length : 0;
                        if (this.cmt > 1000) {
                            this.comment_msg[index] = 'Grading Comment';
                            this.cmtCount++;
                        } else {
                            this.comment_msg[index] = '';
                        }
                         
                        this.validateGradeData(index);
                    });
                    this.subject_ErrMsg = "";
                } else {
                    this.subject_ErrMsg = "Subject Data doesn't exist according to Grade";
                }
                for (let index = this.gradeData.length; index < this.subjectArr.length; index++) {
                    this.second_cmt = this.comment[index] ? this.comment[index].length : 0;
                    if (this.second_cmt > 1000) {
                        this.secondcomment_msg[index] = 'Grading Comment';
                        this.cmtCount++;
                    } else {
                        this.secondcomment_msg[index] = '';
                    }
                    
                    this.validateSubjectArrData(index);
                } 
                this.subject_ErrMsg = '';

                if (this.msgCount > 0 || this.cmtCount > 0) {  
                    this.isLoading = false;
                    return;
                }
            }
            this.update();
        },

        validateGradeData(index) {
            this.firstmark_ErrMsg[index] = '';
            this.firstgrade_ErrMsg[index] = '';

            let validMarkFound = true;
            if (this.gradeData[index]['mark'] == undefined || this.gradeData[index]['mark'] == 0) {
                validMarkFound = false;
            } else if (this.gradeData[index]['mark'] < 0 || this.gradeData[index]['mark'] > 100) {
                this.firstmark_ErrMsg[index] = "Mark must be between 0 and 100";
                this.msgCount++;
            } else {
                this.firstmark_ErrMsg[index] = '';
            }

            let validGradeFound = true;
            if (this.gradeData[index]['grade'] == undefined || this.gradeData[index]['grade'] == 0) {
                validGradeFound = false;
            } else if (this.gradeData[index]['grade'].length > 10) {
                this.firstgrade_ErrMsg[index] = "Grade must be at most 10 characters.";
                this.msgCount++;
            } else if (!this.VALID_GRADES.includes(this.gradeData[index]['grade'])){
                this.firstgrade_ErrMsg[index] = `Grade "${this.gradeData[index]['grade']}" is not valid.`;
                this.msgCount++;
            } else {
                this.firstgrade_ErrMsg[index] = '';
            }

            if (this.allGradesAndMarksEmpty && !validMarkFound && !validGradeFound) {
                this.firstmark_ErrMsg[index] = "Either grade or mark is required.";
                this.firstgrade_ErrMsg[index] = "Either grade or mark is required.";
                this.msgCount++;
            }
        },

        validateSubjectArrData(index) {
            this.secondmark_ErrMsg[index] = '';
            this.secondgrade_ErrMsg[index] = '';

            let validMarkFound = true;
            if (this.marks[index] == undefined || this.marks[index] == 0) {
                validMarkFound = false;
            } else if (this.marks[index] < 0 || this.marks[index] > 100) {
                this.secondmark_ErrMsg[index] = "Mark must be between 0 and 100";
                this.msgCount++;
            } else {
                this.secondmark_ErrMsg[index] = '';
            }

            let validGradeFound = true;
            if (this.grades[index] == undefined || this.grades[index] == 0) {
                validGradeFound = false;
            } else if (this.grades[index].length > 10) {
                this.secondgrade_ErrMsg[index] = "Grade must be at most 10 characters.";
                this.msgCount++;
            } else if (!this.VALID_GRADES.includes(this.grades[index])){
                this.secondgrade_ErrMsg[index] = `Grade "${this.grades[index]}" is not valid.`;
                this.msgCount++;
            } else {
                this.secondgrade_ErrMsg[index] = '';
            }

            if (this.allGradesAndMarksEmpty && this.marks.length == 0 && this.grades.length == 0) {
                if (!validMarkFound && !validGradeFound) {
                    this.secondmark_ErrMsg[index] = "Either grade or mark is required.";
                    this.secondgrade_ErrMsg[index] = "Either grade or mark is required.";
                    this.msgCount++;
                }
            }
        },

        update() {
            var request = {
                academic_year: this.academic_year,
                class_id: this.class_id,
                student_id: this.student_id,
                campus_id: store.state.user.campus_id,
                created_id: store.state.user.id,
                gradeData: this.gradeData,
                exam_id: this.exam_id,
                marks: this.marks,
                grades: this.grades,
                gradeComments: this.comment,
                old_exam_id: this.$route.params.exam_id,
                subjectsArr: this.subjectArr,
            }

            axios.post("/grading/update/" + this.$route.params.student_id, request, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
                .then(response => {
                    if (response.data.status == 200) {
                        this.$notification.success("Grading Updated Successfully", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                        this.$router.push({
                            name: "gradingList"
                        });
                    }
                    else if (response.data.success == false) {
                        this.isLoading = false;
                        this.$notification.error(response.data.message, {
                            timer: 3,
                            position: "bottomCenter",
                        });
                    }
                    if (response.data.status == 201) {
                        this.isLoading = false;
                        this.$notification.error("Grading Data Already Exist", {
                            timer: 3,
                            position: "bottomCenter",
                        });
                    }
                })
                .catch(error => {
                    if (error.response.status == 401) {                       
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    console.log("Grading Edit API Error", error.errors);
                    this.isLoading = false;
                });
        },

        showList() {
            this.$router.push({
                path: "/grading/list"
            });
        },
    },

    mounted() {
        this.isLoading = true;
        this.getThisAcademicYear();
        this.getAcademicYear();
        this.getGradingDetail();
        this.getValidGrades();
    },
};
